import { motion, useInView } from "framer-motion";
import { useRef } from "react";

/* Staggered word-by-word reveal. Adapted to JS for MDM Forge (CRA). */
export const WordsPullUp = ({ text, className = "", style, delayStart = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const words = text.split(" ");

  return (
    <span ref={ref} className={`inline-flex flex-wrap ${className}`} style={style}>
      {words.map((word, i) => {
        const isLast = i === words.length - 1;
        return (
          <motion.span
            key={i}
            initial={{ y: 20, opacity: 0 }}
            animate={isInView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: delayStart + i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="inline-block"
            style={{ marginRight: isLast ? 0 : "0.28em" }}
          >
            {word}
          </motion.span>
        );
      })}
    </span>
  );
};

/* Multi-style variant: each segment can carry its own className (e.g. an accent color). */
export const WordsPullUpMultiStyle = ({ segments, className = "", style, delayStart = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const words = [];
  segments.forEach((seg) => {
    seg.text.split(" ").forEach((w) => {
      if (w) words.push({ word: w, className: seg.className });
    });
  });

  return (
    <span ref={ref} className={`inline-flex flex-wrap ${className}`} style={style}>
      {words.map((w, i) => (
        <motion.span
          key={i}
          initial={{ y: 20, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: delayStart + i * 0.08, ease: [0.16, 1, 0.3, 1] }}
          className={`inline-block ${w.className ?? ""}`}
          style={{ marginRight: "0.28em" }}
        >
          {w.word}
        </motion.span>
      ))}
    </span>
  );
};
